import { registerSystemInfoTab } from "routes/sfg20-admin/plugins/system-info/register-system-info-tab"
import { Geography } from "routes/sfg20-admin/plugins/system-info/location-analytics-tab/geography"

registerSystemInfoTab("Location Analytics", <Geography $lazy />, 100)
